<template>
    <div class="check-item">
        <div class="icon" :class="[item.result ? 'yes' : 'no-' + item.type]" @click="openDetail(item)" v-bd-track-event="['营销力诊断', '点击诊断项的查看详情（黄色、蓝色、绿色按钮），' + item.title]">
            <img :src="getImg(item.result)">
        </div>
        <p class="content textEllipsis" :title="item.title">{{item.title}}</p>
        <el-button v-bd-track-event="['营销力诊断', '点击诊断项的手工加分按钮，' + item.title]" v-if="!item.result && isFinish" type="primary" class="item-btn" @click="recoverScore(item)">手工加分</el-button>
    </div>
</template>

<script>
 	export default {
		props: {
			item: {},
            isFinish: false
        },
		data () {
			return {}
		},
        methods: {
            getImg (result) {
                return 'content/images/check-icon-' + (result ? 'success' : 'error') + '.png';
            },
	        openDetail (item) {
                if (!this.isFinish) {
                    this.$message('请等待检测完成查看');
                    return;
                }
	        	this.$emit('openDetail', item);
            },
            recoverScore (item) {
	            this.$emit('recoverScore', item);
            }
        }
	}
</script>

<style lang="scss" scoped>
    .check-item {
        $width: 6rem;
        $successColor: #42b86b;
        $failColor: #e1a900;
        float: left;
        width: $width + 3rem;
        margin: 0 2.58rem 1.5rem 0;
        text-align: center;
        background-size: auto 50%;
        .icon {
            width: $width;
            height: $width;
            text-align: center;
            line-height: $width;
            color: #fff;
            margin: 0 auto;
            padding: 1.5rem;
            border-radius: 50%;
            cursor: pointer;
            &.yes {
                background-color: $successColor;
            }
            &.no-1 {
                background-color: $failColor;
            }
            &.no-2 {
                background-color: #00b9e1;
            }
            > img {
                display: block;
                width: 100%;
            }
        }
        .content {
            color: #76767b;
            font-size: 16px;
            margin-top: 7px;
        }
        .item-btn {
            border-color: #ccc;
            background-color: #ccc;
            padding: 5px 15px;
            &:hover {
                background-color: #2573e8;
                border-color: #2573e8;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// app/view/detail/ListItem.vue